import { css } from 'linaria';
import { styled } from 'linaria/react';

export const starAtTitle = css`
  margin-left: 5px;
`;
export const scoreAtTitle = css`
  margin-left: 4px;
`;

export const sortingsDropdown = css`
  width: 100%;

  @media (--from-desktop) {
    width: 50%;
  }
`;

export const ComponentCntr = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
